"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var StarIcon = function StarIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.2891 7.64925C18.1816 7.33425 17.8974 7.11175 17.5657 7.08592L12.8149 6.70842L10.7591 2.15758C10.6249 1.85841 10.3274 1.66675 9.9999 1.66675C9.6724 1.66675 9.3749 1.85841 9.24073 2.15675L7.1849 6.70842L2.43407 7.08592C2.10823 7.11175 1.8274 7.32591 1.71657 7.63341C1.60573 7.94092 1.68407 8.28508 1.91823 8.51341L5.42907 11.9359L4.1874 17.3126C4.11073 17.6451 4.2449 17.9909 4.52573 18.1851C4.66907 18.2834 4.83407 18.3334 4.9999 18.3334C5.16073 18.3334 5.3224 18.2867 5.4624 18.1934L9.9999 15.1684L14.5374 18.1934C14.8274 18.3867 15.2082 18.3792 15.4916 18.1734C15.7732 17.9676 15.8974 17.6067 15.8016 17.2717L14.2774 11.9384L18.0574 8.53675C18.3049 8.31342 18.3957 7.96508 18.2891 7.64925Z",
    fill: color
  }));
};
var _default = StarIcon;
exports.default = _default;